import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, List, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton } from "@mui/material";
import "./MobileNavbar.css";
import { navbarData } from "./navabarData";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store";
import { selectAuthUser } from "../../store/selectors";

interface MobileNavabarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const MobileNavabar = ({ isOpen, setIsOpen }: MobileNavabarProps) => {
  const navigate = useNavigate();
  const user = useAppSelector(selectAuthUser);
  const isAdmin = user?.role === 'admin';
  
  console.log("MobileNavabar rendered, isOpen:", isOpen);
  
  const handleClose = () => {
    console.log("Closing mobile navbar");
    setIsOpen(false);
  };

  const handleItemClick = (href: string) => {
    console.log("Navigating to:", href);
    navigate(href);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "background.paper",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header with close button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="h6" component="div">
          Menu
        </Typography>
        <IconButton onClick={handleClose} size="large">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Navigation items */}
      <List sx={{ flex: 1, pt: 2 }}>
        {navbarData.filter(item => !item.adminOnly || isAdmin).map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton
              onClick={() => handleItemClick(item.href)}
              sx={{
                py: 2,
                px: 3,
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
            >
              <ListItemIcon>
                <item.Icon />
              </ListItemIcon>
              <ListItemText 
                primary={item.name}
                primaryTypographyProps={{
                  fontSize: "1.1rem",
                  fontWeight: 500,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export const MenuIconDisplay = ({ isOpen, setIsOpen }: MobileNavabarProps) => {
  const handleClick = () => {
    console.log("Menu icon clicked, setting isOpen to true");
    setIsOpen(true);
  };

  return (
    <Box className="menu-icon-mobile">
      <IconButton onClick={handleClick}>
        <MenuIcon />
      </IconButton>
    </Box>
  );
};
